<script type="text/javascript">
  import { range } from 'lodash';

  export default {
    props: {
      showHeader: {
        type: Boolean,
        default: true,
      },
      num: {
        type: Number,
        default: 1,
      },
    },
    computed: {
      dummyComponents() {
        return range(0, this.num);
      },
    },
  };
</script>

<template>
  <div class="table-rows-loader">
    <div class="table-rows-loader__header">

    </div>
    <div class="table-rows-loader__content">
      <div
        v-for="index in dummyComponents"
        class="table-rows-loader__content-item"
      >
        <div class="table-rows-loader__content-item-text-1"></div>
        <div class="table-rows-loader__content-item-text-2"></div>
        <div class="table-rows-loader__content-item-text-3"></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .table-rows-loader {
    @import '~styles/settings';

    &__header {
      background: $blue1;
      padding: 9px;
      width: 100%;
      height: 22px;
    }

    &__content {
      &-item {
        background: $white;
        padding: 10px 20px;
        border-bottom: 1px solid $grey2;

        &-text-1 {
          margin: 5px 0;

          @include text-line(100%, 9px);
        }

        &-text-2 {
          margin: 5px 0;

          @include text-line(70%, 9px);
        }

        &-text-3 {
          margin: 5px 0;

          @include text-line(40%, 9px);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/content-loader/TableRowsLoader.vue